/* 🤖 this file was generated by script */
export const wsolidiconCoins01 = {
  name: 'coins_01',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M7.2 7.2a8 8 0 1 0 3.6 15.6A8 8 0 0 0 7.2 7.2"/><path fill="currentColor" d="M8.04 5.05Q8.52 5 9 5a10 10 0 0 1 9.95 10.96A8 8 0 1 0 8.05 5.05"/></svg>`,
  iconStyle: 'solid',
};
